
import apiClient from '@/services/axios'

class PromoCodeService {
  constructor() {
    this.$api = apiClient
  }

  getProducts() {
    return this.$api.get('/admin/force-priority')
  }

  getCompanies() {
    return this.$api.get('/admin/force-priority/all-companies')
  }

  getCompanyProducts(companyId, searchValue) {
    return this.$api.get(`/admin/products/by-company/${companyId}?search=${searchValue}`)
  }

  createProduct(payload) {
    return this.$api.post('/admin/force-priority', payload)
  }

  updateProduct(id, payload) {
    return this.$api.put(`/admin/force-priority/${id}`, payload)
  }

  deleteProduct(id) {
    return this.$api.delete(`/admin/force-priority/${id}`)
  }
}

export default new PromoCodeService()
